import React from "react";
import { useNavigate } from "react-router-dom";

const NotAutorizePage = () => {
  const navigate = useNavigate();

  const returnHome = () => {
    navigate("/");
  };

  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{
        height: "100vh",
        backgroundImage: `url(${"/not_autorize_background.jpg"})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div
        className="d-flex flex-column justify-content-center align-items-center"
        style={{
          // backgroundColor: "rgba(0, 0, 0, 0.5)",
          padding: "2rem",
          borderRadius: "1rem",
        }}
      >
        <div
          className="d-flex justify-content-center align-items-center"
          style={{
            height: "20rem",
            width: "20rem",
            backgroundImage: `url(${"/not_autorize.png"})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            borderRadius: "1rem",
            marginBottom: "1rem",
          }}
        />
        <p className="text-center fs-4 text-primary">
          You are not authorized to view this page.
        </p>
        <button className="btn btn-primary" onClick={returnHome}>
          <b>Go Back Home</b>
        </button>
      </div>
    </div>
  );
};

export default NotAutorizePage;
